<template>
  <div>
    <div slot="header" class="clearfix">
      <span>{{ title }}</span>
    </div>
    <el-upload
      ref="upload"
      class="upload-block"
      drag
      :limit="2"
      :http-request="handleUpload"
      action="#"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :disabled="disabled"
      :accept="accept"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { createStorage, delStorage, listStorage } from "@/api/storage";
export default {
  name: "UploadFile",
  props: {
    url: String,
    title: String,
    category: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    accept: {
      type: String,
      required: false,
      default: "application/pdf"
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  mounted() {},
  methods: {
    getList() {
      listStorage({ category: this.category, sub_category: this.sub_category })
        .then(response => {
          if (response.data.count > 0) {
            this.fileList = response.data.results.map(result => {
              return { id: result.id, name: result.name, url: result.url };
            });
          }
        })
        .catch(err => {
          this.$message.error("Error: " + JSON.stringify(err));
        });
    },
    handleRemove(file, fileList) {
      delStorage(file.id)
        .then(response => this.getList())
        .catch(err => {
          this.$message.error("Error: " + JSON.stringify(err));
        });
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 2, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Delete ${file.name} ?`);
    },
    handleUpload(item) {
      const formData = new FormData();
      formData.append("file", item.file);
      this.$axios({
        url: "http://39.108.13.114:9899/" + this.url,
        method: "post",
        headers: {
          "Content-type": "multipart/form-data"
        },
        data: formData
      })
      .catch(err => {
        console.log(err);
        this.$message.error("上传失败，请重新上传");
      });
    }
  }
};
</script>

<style>
.upload-block .el-upload-dragger {
  width: 150% !important;
}
</style>
